import { render, staticRenderFns } from "./ChangePoiModal.vue?vue&type=template&id=b1362074&scoped=true"
import script from "./ChangePoiModal.vue?vue&type=script&lang=ts"
export * from "./ChangePoiModal.vue?vue&type=script&lang=ts"
import style0 from "./ChangePoiModal.vue?vue&type=style&index=0&id=b1362074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1362074",
  null
  
)

export default component.exports